/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Go Cancel locations row
 * @export
 * @interface GoCancelsRow
 */
export interface GoCancelsRow {
    /**
     * 空車での trip_session_id
     * @type {string}
     * @memberof GoCancelsRow
     */
    unladenTripSessionId?: string;
    /**
     * ログイン(開局) 単位で発行されるID
     * @type {string}
     * @memberof GoCancelsRow
     */
    loginSessionId?: string;
    /**
     * GO cancel timestamp
     * @type {string}
     * @memberof GoCancelsRow
     */
    goCancelTs?: string;
    /**
     * GO cancel location coords
     * @type {object}
     * @memberof GoCancelsRow
     */
    goCancelLocCoords?: object;
}

export function GoCancelsRowFromJSON(json: any): GoCancelsRow {
    return GoCancelsRowFromJSONTyped(json, false);
}

export function GoCancelsRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoCancelsRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'unladenTripSessionId': !exists(json, 'unladen_trip_session_id') ? undefined : json['unladen_trip_session_id'],
        'loginSessionId': !exists(json, 'login_session_id') ? undefined : json['login_session_id'],
        'goCancelTs': !exists(json, 'go_cancel_ts') ? undefined : json['go_cancel_ts'],
        'goCancelLocCoords': !exists(json, 'go_cancel_loc_coords') ? undefined : json['go_cancel_loc_coords'],
    };
}

export function GoCancelsRowToJSON(value?: GoCancelsRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'unladen_trip_session_id': value.unladenTripSessionId,
        'login_session_id': value.loginSessionId,
        'go_cancel_ts': value.goCancelTs,
        'go_cancel_loc_coords': value.goCancelLocCoords,
    };
}


